import React, { useState, useEffect } from 'react'
import StudentTopMenu from './studenttopmenu'
import { getStudentIdData } from '../../../lib/studentappcheckview'
import { useParams } from 'react-router-dom'

export default function AdminStudentAppCheck() {
  const [studentBookList, setStudentBookList] = useState()
  const [studentInfo, setStudentInfo] = useState()

  let { slug } = useParams()

  async function GetData() {
    const info = await getStudentIdData(slug)
    setStudentBookList(info)
    //setStudentInfo(info[0].name + " " + info[0].surname)
    console.log('info', info)
  }

  useEffect(() => {
    GetData()
  }, [])
  return (
    <div className='col-12'>
      <div className='tak-instruct-group'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='settings-widget'>
              <div className='settings-inner-blk p-0'>
                <div className='sell-course-head comman-space'>
                  <h3>Payout Method</h3>
                  <p>
                    Order Dashboard is a quick overview of all current orders.
                  </p>
                </div>
              </div>
            </div>
            <StudentTopMenu slug={slug} activeMenu={'AppCheck'} />
            <div className='settings-widget'>
              <div className='settings-inner-blk p-0'>
                <div className='checkout-form personal-address add-course-info'>
                  <div className='personal-info-head'>
                    <h4>
                      Student Application Check List -{' '}
                      <span className='fs-2 text-info'>{studentInfo}</span>
                    </h4>
                  </div>
                  <div className='comman-space pb-0'>
                    <div className='settings-referral-blk course-instruct-blk  table-responsive'>
                      {/* Instructor Users */}
                      <table className='table table-nowrap mb-0'>
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>CATEGORY</th>
                            <th>QUESTION</th>
                            <th>STATUS</th>
                          </tr>
                        </thead>
                        <tbody>
                          {studentBookList
                            ? studentBookList.map(function (data) {
                                return (
                                  <tr key={data.appid}>
                                    <td>{data.appid}</td>
                                    <td>{data.pname}</td>
                                    <td>{data.question}</td>
                                    <td>
                                      {data.isCheck ? (
                                        <span className='badge info-low'>
                                          Yes
                                        </span>
                                      ) : (
                                        <span className='badge info-high'>
                                          Not Yet
                                        </span>
                                      )}
                                    </td>
                                  </tr>
                                )
                              })
                            : ''}
                        </tbody>
                      </table>
                      {/* Instructor List */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
